import { Component } from '@angular/core';

import { AboutPage } from '../about/about';
import { SettingPage } from '../setting/setting';
import { HomePage } from '../home/home';
import { AdminPage } from "../admin/admin";

import { WelcomePage } from '../welcome/welcome';
import { Tabs } from 'ionic-angular/components/tabs/tabs';
import { ViewChild } from '@angular/core';

import { NavParams } from 'ionic-angular';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage {
  @ViewChild("tabs") tabRef: Tabs;

  tab1Root = HomePage;
  tab2Root = AboutPage;
  tab3Root = AdminPage;
  tab4Root = SettingPage;
  tab5Root = WelcomePage;

  private params: any;

  constructor(public navParams: NavParams) {
//    console.log("0");
  }

  ionViewWillEnter() {
    //  TODO: Determine the condition that will set this attribute.
    let isAdmin: boolean = true;
    this.conditionallyInjectAdminMenu(isAdmin);
  }

  ionViewDidLoad() {
//        console.log("1");
  }

  ionViewDidEnter() {
    //    console.log("3");
  }

  ionViewWillLeave() {
//    console.log("4");
  }

  ionViewDidLeave() {
//    console.log("5");
  }

  ionViewWillUnload() {
//    console.log("6");
  }

  ionViewCanEnter() {
//    console.log("7");
  }

  ionViewCanLeave() {
//    console.log("8");
  }

  private conditionallyInjectAdminMenu(isAdmin) {
    for (let tab of this.tabRef._tabs) {
      if (tab.tabTitle == "Home") {
        tab.rootParams = this.params;
        break;
      }

      if (tab.tabTitle == "Admin") {
        tab.show = isAdmin;
        tab.rootParams = this.params;
        break;
      }
    }
  };
}


// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts